import { render, staticRenderFns } from "./registration-from-qr.vue?vue&type=template&id=7244727c&scoped=true&"
import script from "./registration-from-qr.vue?vue&type=script&lang=js&"
export * from "./registration-from-qr.vue?vue&type=script&lang=js&"
import style0 from "./registration-from-qr.vue?vue&type=style&index=0&id=7244727c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7244727c",
  null
  
)

export default component.exports